import { defineMessages } from 'react-intl';

export default defineMessages({
  // ----- Section headers --------------------------------------------------
  sectionWorkflows: {
    id: 'appSidebar.section.workflows',
    defaultMessage: 'Workflows',
  },
  sectionInsights: {
    id: 'appSidebar.section.insights',
    defaultMessage: 'Insights',
  },
  sectionAdvancedTools: {
    id: 'appSidebar.section.advancedTools',
    defaultMessage: 'Advanced tools',
  },
  sectionConfigure: {
    id: 'appSidebar.section.configure',
    defaultMessage: 'Configure',
  },
  // ----- Item labels ------------------------------------------------------
  assets: {
    id: 'appSidebar.item.assets',
    defaultMessage: 'Assets',
  },
  collections: {
    id: 'appSidebar.item.collections',
    defaultMessage: 'Collections',
  },
  shares: {
    id: 'appSidebar.item.shares',
    defaultMessage: 'Shares',
  },
  overview: {
    id: 'appSidebar.item.overview',
    defaultMessage: 'Account Usage',
  },
  aiUsage: {
    id: 'appSidebar.item.aiUsage',
    defaultMessage: 'Credits Usage',
  },
  agentActivity: {
    id: 'appSidebar.item.agentActivity',
    defaultMessage: 'Agent activity',
  },
  deliveryAnalytics: {
    id: 'appSidebar.item.deliveryAnalytics',
    defaultMessage: 'Delivery Insights',
  },
  analyticsDestinations: {
    id: 'appSidebar.item.analyticsDestinations',
    defaultMessage: 'Analytics Integrations',
  },
  notifications: {
    id: 'appSidebar.item.notifications',
    defaultMessage: 'Notifications',
  },
  reviews: {
    id: 'appSidebar.item.reviews',
    defaultMessage: 'Reviews',
  },
  myApprovals: {
    id: 'appSidebar.item.myApprovals',
    // Renamed from "My approvals" 2026-09-02. Two thirds of what lands on
    // that page is not an approval: `TTaskIntent` is approve | comment | fix
    // ("Check & approve" / "Take a look" / "Fix & re-upload"), and the
    // resolution verbs are DONE | DECLINED | DISMISSED — there is no approve
    // button on it. "Approvals" also already names the external share lane's
    // per-asset PENDING -> APPROVED | REJECTED verdicts, which have their own
    // tab on /shares/:id, so the word pointed at two different things.
    //
    // "Assigned to me" is the Jira/GitHub scope phrasing and is literally
    // what the data is (`assigned_to_email`). `Reviews` on the row above is
    // deliberately left alone: the contrast between the two carries the
    // requester/reviewer split without either label repeating the other.
    // The message id stays — it is an identifier, not copy.
    defaultMessage: 'Assigned to me',
  },
  jobs: {
    id: 'appSidebar.item.jobs',
    defaultMessage: 'Jobs',
  },
  reprocessAssets: {
    id: 'appSidebar.item.reprocessAssets',
    defaultMessage: 'Reprocess Assets',
  },
  getAssetLinks: {
    id: 'appSidebar.item.getAssetLinks',
    defaultMessage: 'Get Asset Links',
  },
  cdnPrefetch: {
    id: 'appSidebar.item.cdnPrefetch',
    defaultMessage: 'CDN Prefetch / Purge',
  },
  reissueCallbacks: {
    id: 'appSidebar.item.reissueCallbacks',
    defaultMessage: 'Re-issue Callbacks',
  },
  bulkPurge: {
    id: 'appSidebar.item.bulkPurge',
    defaultMessage: 'Bulk Purge Assets',
  },
  taskQueues: {
    id: 'appSidebar.item.taskQueues',
    defaultMessage: 'Task Queues',
  },
  subscription: {
    id: 'appSidebar.item.subscription',
    defaultMessage: 'Subscription',
  },
  settings: {
    id: 'appSidebar.item.settings',
    defaultMessage: 'Settings',
  },
  assetSchemas: {
    id: 'appSidebar.item.assetSchemas',
    defaultMessage: 'Asset Schemas',
  },
  sharePresets: {
    id: 'appSidebar.item.sharePresets',
    defaultMessage: 'Share Presets',
  },
  addons: {
    id: 'appSidebar.item.addons',
    defaultMessage: 'Add-ons',
  },
  migrate: {
    id: 'appSidebar.item.migrate',
    defaultMessage: 'Migrate to FileSpin',
  },
  aiSchedules: {
    id: 'appSidebar.item.aiSchedules',
    // Renamed from "AI schedules" 2026-09-02. "AI" named the technology, not
    // the job, and a plural config-noun read as settings — which is the exact
    // filing this item was moved out of. "Agent workflows" was considered and
    // rejected: this section is already called Workflows, `Workflow
    // Integrations` (Make/Zapier/n8n) is a different shipped surface, and
    // `approval-workflow` is a schema-preset feature. The message id is
    // deliberately unchanged — it is an identifier, not copy.
    defaultMessage: 'Scheduled agents',
  },
  users: {
    id: 'appSidebar.item.users',
    defaultMessage: 'Teams & Users',
  },
  // ----- Chrome -----------------------------------------------------------
  toggleCollapse: {
    id: 'appSidebar.toggleCollapse',
    defaultMessage: 'Collapse sidebar',
  },
  toggleExpand: {
    id: 'appSidebar.toggleExpand',
    defaultMessage: 'Expand sidebar',
  },
  primaryNavigation: {
    id: 'appSidebar.primaryNavigation',
    defaultMessage: 'Primary navigation',
  },
  mobileToggle: {
    id: 'appSidebar.mobileToggle',
    defaultMessage: 'Toggle navigation',
  },
  sectionFold: {
    id: 'appSidebar.sectionFold',
    defaultMessage: 'Collapse {section} section',
  },
  sectionUnfold: {
    id: 'appSidebar.sectionUnfold',
    defaultMessage: 'Expand {section} section',
  },
});
